var map = {
	"./da.json": [
		"./src/js/translations/da.json",
		41
	],
	"./de.json": [
		"./src/js/translations/de.json",
		42
	],
	"./en.json": [
		"./src/js/translations/en.json",
		43
	],
	"./es.json": [
		"./src/js/translations/es.json",
		44
	],
	"./fr.json": [
		"./src/js/translations/fr.json",
		45
	],
	"./it.json": [
		"./src/js/translations/it.json",
		46
	],
	"./nl.json": [
		"./src/js/translations/nl.json",
		47
	],
	"./no.json": [
		"./src/js/translations/no.json",
		48
	],
	"./pt-BR.json": [
		"./src/js/translations/pt-BR.json",
		49
	],
	"./ru.json": [
		"./src/js/translations/ru.json",
		50
	],
	"./sv.json": [
		"./src/js/translations/sv.json",
		51
	],
	"./whitelist_en.json": [
		"./src/js/translations/whitelist_en.json",
		52
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/js/translations lazy recursive ^\\.\\/.*\\.json$";
module.exports = webpackAsyncContext;